import { useState, useEffect, useRef } from 'react';
import { signOut } from 'firebase/auth';
import { BsFillPersonFill } from 'react-icons/bs';
import { MdOutlineMenu, MdLogout } from 'react-icons/md';

const TopBar = (props) => {

    const [showMenu, toggleMenu] = useState(false);
    const profileButtonRef = useRef(null);
    const profileMenuRef = useRef(null);

    const hideProfileMenuHandler = (e) => {
        if(profileMenuRef.current && !profileMenuRef.current.contains(e.target)){
            if(profileButtonRef.current && e.target !== profileButtonRef.current){
                toggleMenu(false);
            }
        }
    }

    useEffect(() => {
        document.addEventListener('click', hideProfileMenuHandler);
    },[]);

    const logout = (e) => {
        e.preventDefault();
        signOut(props.auth);
        props.router('', {replace: true});
    }

    return (
        <div className='Topbar'>
            <div className='d-flex jf-center tx-white'>
                <button className='ibtn d-dinamic pr-1' onClick={() => {props.toggleMethod(!props.toggle); props.collapseBar(false);} } >
                    <MdOutlineMenu size="1.5rem" color='white' pointerEvents="none"/>
                </button>
                <span>Administrador</span>
            </div>
            <div>
                <button className='cbtn bg-primary' onClick={() => toggleMenu(!showMenu)} ref={profileButtonRef}>
                    <BsFillPersonFill size='1.5rem' color='white' pointerEvents="none"/>
                </button>

                <div className='profileMenu' style={{display: showMenu? 'block':'none'}} ref={profileMenuRef}>
                    <span>
                        <a href='#menu' className='d-flex tx-alt' onClick={(e) => logout(e)}>
                            <div className='d-flex'>
                                <MdLogout className='menuIcon' size='1.5rem' color='black' />
                            </div>
                            <div className='d-flex pl-1'>
                                Cerrar Sesion
                            </div>
                        </a>
                    </span>
                </div>
            </div>
        </div>
    );
}

export default TopBar;